export default __webpack_public_path__ + "static/media/cancelled.1bff77df.svg";